export const TOAST = '@notification/toast';
export const EVENT = '@notification/event';
export const CLOSE = '@notification/close';
export const RESET_UNSEEN = '@notification/reset-unseen';
export const REMOVE = '@notification/remove';
